import { I18n } from '@calendly/i18n'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'

const LEGACY_PREFIX = 'publisher.workflows.'
const REBRAND_PREFIX = 'publisher.workflows_app_shell_rebrand.workflows.'

/**
 * Resolve `publisher.workflows.*` copy from the mirrored tree
 * `publisher.workflows_app_shell_rebrand.workflows.*` when the app-shell IA rebrand flag is on.
 *
 * Prefer `usePublisherWorkflowsT` in React components; use this directly only
 * when the flag value is already available (e.g. non-hook contexts).
 */
export function publisherWorkflowsT(key, isRebrandEnabled, options) {
  if (!key.startsWith(LEGACY_PREFIX)) {
    return I18n.t(key, options)
  }
  if (!isRebrandEnabled) {
    return I18n.t(key, options)
  }
  const rebranded = REBRAND_PREFIX + key.slice(LEGACY_PREFIX.length)
  const translated = I18n.t(rebranded, options)
  if (translated === rebranded) {
    return I18n.t(key, options)
  }
  return translated
}

/**
 * React hook that reads the app-shell rebrand flag and returns a translation
 * function with the flag already bound. Replaces direct `I18n.t` calls so
 * call sites don't need to thread the flag value themselves:
 *
 *   const t = usePublisherWorkflowsT()
 *   t('publisher.workflows.some.key')
 */
export function usePublisherWorkflowsT() {
  const isRebrandEnabled = useProductRefreshAppShell()
  return (key, options) => publisherWorkflowsT(key, isRebrandEnabled, options)
}
